import { faArrowLeft, faArrowRight, faLink } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const EventCard = (props) => {
    const [currentSlide, setCurrentSlide] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSlide((prevSlide) => (prevSlide === props.event.images?.length - 1 ? 0 : prevSlide + 1));
        }, 3200);

        return () => {
            clearInterval(interval);
        };
    }, [props.event.images?.length]);

    const handlePrevSlide = () => {
        setCurrentSlide((prevSlide) => (prevSlide === 0 ? props.event.images?.length - 1 : prevSlide - 1));
    };

    const handleNextSlide = () => {
        setCurrentSlide((prevSlide) => (prevSlide === props.event.images?.length - 1 ? 0 : prevSlide + 1));
    };

    return (
        <div className='events-card'>
            {
                props.event.images?.length ?
                    <div className='slider-imgbox'>
                        {/* image slider */}
                        {
                            props.event.images.map((image, index) => (
                                <img
                                    key={index}
                                    src={image}
                                    alt='backgrnd'
                                    className={`slider-image ${index === currentSlide ? 'active' : ''}`}
                                />
                            ))
                        }
                        {
                            props.event.images?.length > 1 ?
                                <>
                                    <button className='prev-button' onClick={handlePrevSlide}>
                                        <FontAwesomeIcon icon={faArrowLeft} />
                                    </button>
                                    <button className='next-button' onClick={handleNextSlide}>
                                        <FontAwesomeIcon icon={faArrowRight} />
                                    </button>
                                </>
                                : <></>
                        }
                    </div>
                    : <></>
            }

            <div className='event-details'>
                <Link to={props.event.url}>
                    <FontAwesomeIcon icon={faLink} />
                    <h2 className='event-heading underline'>{props.event.name}</h2>
                    {/* <FontAwesomeIcon icon={faArrowCircleRight} /> */}
                </Link>
                <p className='event-date'>📅 Date: <span className="underline">{props.event.date.toLocaleDateString('en-GB')}</span></p>
                <p className='event-time'>⏰ Time: <span className="underline">{props.event.time}</span></p>
                <p className='event-description'>
                    {props.event.description}
                </p>
            </div>
            <div className="event-redirect-wrapper">
                <Link to={props.event.url} className="event-redirect">
                    Know more...
                </Link>
            </div>
        </div>

    )
}

export default EventCard